import React from 'react';
import { format } from 'date-fns';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { CalendarDays } from 'lucide-react';
import { DayPicker } from 'react-day-picker';
import { twMerge } from 'tailwind-merge';
import 'react-day-picker/dist/style.css';

export default function DateRangePicker({ range, setRange, className }) {
  const formattedRange =
    range?.from && range?.to
      ? `${format(range.from, 'dd/MM/yyyy')} → ${format(
          range.to,
          'dd/MM/yyyy',
        )}`
      : 'Select date range';

  return (
    <>
      <Popover className={twMerge('relative', className)}>
        <PopoverButton className="inline-flex text-base items-center px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 text-gray-700 whitespace-nowrap">
          <CalendarDays className="w-5 h-5 mr-2 text-blue-600" />
          {formattedRange}
        </PopoverButton>
        <PopoverPanel
          anchor="bottom end"
          className="mt-1 bg-white border border-gray-300 rounded-lg shadow-lg p-4"
        >
          <DayPicker
            mode="range"
            selected={range}
            onSelect={setRange}
            numberOfMonths={2}
          />
        </PopoverPanel>
      </Popover>
    </>
  );
}
